export default {
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasInsuranceProductInCart() {
            const items = this.$store.state.cart.cart.items;
            return items.some((item) => item.insured_product_sku === this.product.sku);
        },
    },
    methods: {
        setShowModal() {
            if (this.product.linked_insurance_product && this.product.linked_insurance_product.sku && !this.hasInsuranceProductInCart) {
                this.showModal = true;
            }
        },
        productAdded() {
            this.setShowModal();
            !this.showModal && this.$store.dispatch('cart/openCart', true);
        },
    },
};
